
// Rtoaster slider化
window.rtSupport = function(){
  let rtItems = Array.from(document.querySelectorAll('.js-rtoaster-build .rt-recommend-list-unit'));
  if(rtItems){
    rtItems.forEach(elm => {
      if(!elm.hasChildNodes()){
        elm.remove();
      }
    });
  }
  let rtContainer = Array.from(document.querySelectorAll('.js-rtoaster-build'));
  if(rtContainer){
    rtContainer.forEach(container => {
      let itemLength = container.querySelectorAll('.rt-recommend-list-unit').length;
      if(itemLength == 0){
        container.remove();
      }
    });
  }
  if(rtItems){
    rtItems.forEach(elm => {
      if(elm){
        let img = elm.querySelector('img');
        if(img.dataset.src){
          let imgSrcSet = img.dataset.src;
          img.dataset.src = imgSrcSet.replace('_ichiran','');
        }
        let imgSrc = img.src;
        img.src = imgSrc.replace('_ichiran','');
      }
    });
  }
  if(rtContainer){
    rtContainer.forEach(container => {
      if(container){
        let itemLength = container.querySelectorAll('.rt-recommend-list-unit').length;
        if(itemLength != 0){
          const rtLoadEvent = new CustomEvent('rtCalled');
          setTimeout(() => {
            document.body.dispatchEvent(rtLoadEvent);
          }, 10);
        }
      }
    });
  }

}
